/* TRULY LANDING · funciones (solo se carga en la plantilla "truly") */
(function () {
  if (window.__tlpReady) return;
  window.__tlpReady = true;

  /* Abre el formulario Ofertonazos (antes Releasit). Si no aparece, agrega al carrito. */
  function openCOD() {
    if (window.ofzOpen) { window.ofzOpen(); return; }
    var btn = document.querySelector('._rsi-buy-now-button-product') ||
              document.querySelector('._rsi-buy-now-button');
    if (btn) { btn.click(); return; }
    var form = document.querySelector('[id$="__main"] form[action*="/cart/add"]');
    var add = form && form.querySelector('[type="submit"]');
    if (add) add.click();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-tlp-cod]');
    if (t) { e.preventDefault(); openCOD(); }
  });

  function init() {
    /* Packs de la oferta final */
    document.querySelectorAll('.tlp .pack:not([data-i])').forEach(function (p) {
      p.setAttribute('data-i', '1');
      p.addEventListener('click', function () {
        var group = p.closest('.packs');
        group.querySelectorAll('.pack').forEach(function (o) { o.classList.remove('on'); o.setAttribute('aria-checked', 'false'); });
        p.classList.add('on');
        p.setAttribute('aria-checked', 'true');
        var price = p.getAttribute('data-price');
        var label = p.getAttribute('data-label');
        document.querySelectorAll('[data-tlp-total]').forEach(function (el) { el.textContent = price; });
        document.querySelectorAll('[data-tlp-sticky]').forEach(function (el) { el.textContent = label + ' · ' + price; });
      });
      p.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); p.click(); } });
    });

    /* Test "¿Truly es para ti?" */
    document.querySelectorAll('.tlp .quiz:not([data-i])').forEach(function (quiz) {
      quiz.setAttribute('data-i', '1');
      var items = quiz.querySelectorAll('.q');
      var bar = quiz.querySelector('.bar i');
      var txt = quiz.querySelector('[data-q-txt]');
      var sub = quiz.querySelector('[data-q-sub]');
      var t0 = txt ? txt.textContent : '';
      var s0 = sub ? sub.textContent : '';
      function update() {
        var n = quiz.querySelectorAll('.q.on').length, total = items.length;
        if (bar) bar.style.width = (total ? n / total * 100 : 0) + '%';
        if (!txt || !sub) return;
        if (n === 0) { txt.textContent = t0; sub.textContent = s0; }
        else if (n < 3) { txt.textContent = quiz.getAttribute('data-r1'); sub.textContent = 'Marcaste ' + n + ' de ' + total + '. ' + quiz.getAttribute('data-r1s'); }
        else { txt.textContent = quiz.getAttribute('data-r2'); sub.textContent = 'Marcaste ' + n + ' de ' + total + '. ' + quiz.getAttribute('data-r2s'); }
      }
      items.forEach(function (q) {
        q.addEventListener('click', function (e) {
          e.preventDefault();
          var on = q.classList.toggle('on');
          q.setAttribute('aria-checked', on ? 'true' : 'false');
          update();
        });
        q.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); q.click(); } });
      });
    });

    /* Antes y después */
    document.querySelectorAll('.tlp .slider:not([data-i])').forEach(function (s) {
      s.setAttribute('data-i', '1');
      var r = s.querySelector('input[type="range"]');
      if (!r) return;
      var touched = false;
      s.classList.add('hint');
      r.addEventListener('input', function () {
        touched = true;
        s.classList.add('used');
        s.classList.remove('hint');
        s.style.setProperty('--pos', r.value + '%');
      });
      /* Al entrar en pantalla, la línea se mueve sola una vez para mostrar que se arrastra */
      function demo() {
        var keys = [[0, 50], [450, 28], [1050, 72], [1500, 50]], t0 = null;
        function ease(x) { return x < .5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2; }
        function frame(ts) {
          if (touched) return;
          if (t0 === null) t0 = ts;
          var t = ts - t0, v = 50;
          for (var i = 1; i < keys.length; i++) {
            if (t <= keys[i][0]) { var a = keys[i - 1], b = keys[i], p = ease((t - a[0]) / (b[0] - a[0])); v = a[1] + (b[1] - a[1]) * p; break; }
          }
          s.style.setProperty('--pos', v + '%');
          if (t < keys[keys.length - 1][0]) requestAnimationFrame(frame); else { s.style.setProperty('--pos', '50%'); r.value = 50; }
        }
        requestAnimationFrame(frame);
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { io.disconnect(); setTimeout(demo, 300); }
        }, { threshold: 0.6 });
        io.observe(s);
      }
    });

    /* Video principal: barra de progreso y sonido */
    document.querySelectorAll('.tlp .hero-video:not([data-i])').forEach(function (box) {
      box.setAttribute('data-i', '1');
      var v = box.querySelector('video');
      var prog = box.querySelector('.vid-prog i');
      var mute = box.querySelector('.vid-mute');
      if (!v) { if (prog) prog.style.animation = 'none'; return; }
      v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', '');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      v.addEventListener('timeupdate', function () {
        if (prog && v.duration) prog.style.width = (v.currentTime / v.duration * 100) + '%';
      });
      if (mute) mute.addEventListener('click', function () {
        v.muted = !v.muted;
        mute.classList.toggle('sound', !v.muted);
        mute.setAttribute('aria-label', v.muted ? 'Activar sonido' : 'Silenciar');
      });
    });

    /* Reseñas en video: suenan solo al tocarlas; se reproducen mientras están en pantalla */
    var cards = document.querySelectorAll('.tlp .vcard:not([data-i])');
    var watcher = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target.querySelector('video');
        if (!v) return;
        if (en.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.35 }) : null;
    cards.forEach(function (card) {
      card.setAttribute('data-i', '1');
      var v = card.querySelector('video');
      if (!v) return;
      v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      if (watcher) watcher.observe(card); else { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      card.addEventListener('click', function () {
        var turnOn = v.muted;
        document.querySelectorAll('.tlp .vcard').forEach(function (o) {
          var ov = o.querySelector('video');
          if (ov) ov.muted = true;
          o.classList.remove('sound');
          var ob = o.querySelector('.v-mute'); if (ob) ob.setAttribute('aria-label', 'Activar sonido');
        });
        if (turnOn) {
          v.muted = false;
          card.classList.add('sound');
          var b = card.querySelector('.v-mute'); if (b) b.setAttribute('aria-label', 'Silenciar');
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        }
      });
    });

    /* Carrusel de videos: avanza solo cada X segundos */
    document.querySelectorAll('.tlp .vrow:not([data-a])').forEach(function (row) {
      row.setAttribute('data-a', '1');
      var secs = parseInt(row.getAttribute('data-auto'), 10) || 0;
      if (!secs) return;
      var visible = false, pausedUntil = 0;
      function pause() { pausedUntil = Date.now() + 8000; }
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { row.addEventListener(ev, pause, { passive: true }); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.3 }).observe(row);
      } else { visible = true; }
      setInterval(function () {
        if (!visible || Date.now() < pausedUntil || row.querySelector('.vcard.sound')) return;
        var card = row.querySelector('.vcard');
        if (!card) return;
        var step = card.offsetWidth + 12;
        var max = row.scrollWidth - row.clientWidth;
        var target = row.scrollLeft + step;
        if (target > max - 4) target = 0;
        row.scrollTo({ left: target, behavior: 'smooth' });
      }, secs * 1000);
    });

    /* Botón fijo: aparece al pasar el primer botón */
    var sticky = document.querySelector('.tlp-sticky:not([data-i])');
    if (sticky) sticky.setAttribute('data-i', '1');
    var first = document.querySelector('.tlp.hero .cta');
    if (sticky && first && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(first);
    } else if (sticky) { sticky.classList.add('on'); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
